import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

const DAYS = ["Seg", "Ter", "Qua", "Qui", "Sex", "Sáb", "Dom"];
const at = (d, t, end) => new Date(`${d}T${t || (end ? "23:59" : "00:00")}:${end ? "59" : "00"}-03:00`);
const weekdayBR = (now) => (new Date(now.getTime() - 3 * 36e5).getUTCDay() + 6) % 7;
const chip = (on) => cn("rounded-full border px-2 py-0.5 text-[11px] transition-colors", on ? "border-primary bg-primary text-primary-foreground" : "hover:bg-muted");
const COUNTDOWN = [["", "Não mostrar"], ["sempre", "Sempre"], ["24h", "Só nas últimas 24h"]];

export const toBanner = (b) => ({ start_date: "", start_time: "", end_date: "", end_time: "", days: [], countdown: "", ...(typeof b === "string" ? { url: b } : b) });

export function bannerStatus(b, now = new Date()) {
  if (b.start_date && now < at(b.start_date, b.start_time)) return "agendado";
  if (b.end_date && now > at(b.end_date, b.end_time, true)) return "encerrado";
  if (b.days?.length && !b.days.includes(weekdayBR(now))) return "fora";
  return "ativo";
}

const STATUS = {
  ativo: ["No ar agora", "bg-emerald-500/15 text-emerald-600 dark:text-emerald-400"],
  agendado: ["Agendado", "bg-amber-500/15 text-amber-600 dark:text-amber-400"],
  encerrado: ["Encerrado", "bg-muted text-muted-foreground"],
  fora: ["Fora dos dias escolhidos", "bg-muted text-muted-foreground"],
};

export function BannerStatusBadge({ b, testId }) {
  const [label, cls] = STATUS[bannerStatus(b)];
  return <span className={cn("rounded-full px-2 py-0.5 text-[11px] font-semibold", cls)} data-testid={testId}>{label}</span>;
}

function DateTime({ label, d, t, onD, onT, testId }) {
  return (
    <div className="space-y-1">
      <p className="text-[11px] font-medium text-muted-foreground">{label}</p>
      <div className="flex gap-1.5">
        <Input type="date" value={d} onChange={(e) => onD(e.target.value)} className="h-8 min-w-0 flex-1 px-2 text-xs" data-testid={`${testId}-date`} />
        <Input type="time" value={t} onChange={(e) => onT(e.target.value)} disabled={!d} className="h-8 w-[88px] px-2 text-xs" data-testid={`${testId}-time`} />
      </div>
    </div>
  );
}

export function BannerSchedule({ b, i, onChange }) {
  const set = (patch) => onChange({ ...b, ...patch });
  const toggleDay = (d) => set({ days: b.days.includes(d) ? b.days.filter((x) => x !== d) : [...b.days, d].sort() });
  const bad = b.start_date && b.end_date && at(b.end_date, b.end_time, true) < at(b.start_date, b.start_time);
  const any = b.start_date || b.end_date || b.days.length;
  return (
    <div className="space-y-2 border-t p-2" data-testid={`banner-schedule-${i}`}>
      <div className="flex items-center justify-between">
        <p className="text-xs font-medium">Quando mostrar</p>
        {any ? <button type="button" onClick={() => set({ start_date: "", start_time: "", end_date: "", end_time: "", days: [], countdown: "" })} className="text-[11px] text-muted-foreground underline" data-testid={`banner-schedule-clear-${i}`}>Mostrar sempre</button>
          : <span className="text-[11px] text-muted-foreground">Sempre visível</span>}
      </div>
      <div className="grid gap-2 xl:grid-cols-2">
        <DateTime label="Início (opcional)" d={b.start_date} t={b.start_time} onD={(v) => set({ start_date: v, ...(v ? {} : { start_time: "" }) })} onT={(v) => set({ start_time: v })} testId={`banner-start-${i}`} />
        <DateTime label="Fim (opcional)" d={b.end_date} t={b.end_time} onD={(v) => set({ end_date: v, ...(v ? {} : { end_time: "", countdown: "" }) })} onT={(v) => set({ end_time: v })} testId={`banner-end-${i}`} />
      </div>
      <div className="flex flex-wrap items-center gap-1">
        <span className="mr-1 text-[11px] text-muted-foreground">Repetir em:</span>
        {DAYS.map((d, j) => (
          <button key={d} type="button" onClick={() => toggleDay(j)} className={chip(b.days.includes(j))} data-testid={`banner-day-${i}-${j}`}>{d}</button>
        ))}
      </div>
      {b.end_date && (
        <div className="flex flex-wrap items-center gap-1" data-testid={`banner-countdown-${i}`}>
          <span className="mr-1 text-[11px] text-muted-foreground">Contagem regressiva:</span>
          {COUNTDOWN.map(([v, l]) => (
            <button key={l} type="button" onClick={() => set({ countdown: v })} className={chip((b.countdown || "") === v)} data-testid={`banner-countdown-${i}-${v || "off"}`}>{l}</button>
          ))}
        </div>
      )}
      <p className="text-[11px] text-muted-foreground">Sem horário vale o dia inteiro. Sem dias marcados mostra todos os dias.</p>
      {bad && <p className="text-[11px] font-medium text-destructive" data-testid={`banner-schedule-error-${i}`}>O fim precisa ser depois do início.</p>}
    </div>
  );
}
